/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShadowInsuranceRuleResult
 */
export interface ShadowInsuranceRuleResult {
    /**
     * 
     */
    id: string;
    /**
     * The insurance_rules row evaluated; null if it was deleted or the row was backfilled.
     */
    rule_id: string | null;
    /**
     * 
     */
    rule_type: ShadowInsuranceRuleResultRuleTypeEnum;
    /**
     * Display title rendered from the rule catalog with the stored threshold.
     */
    rule_title: string;
    /**
     * 
     */
    qualifier: ShadowInsuranceRuleResultQualifierEnum;
    /**
     * 
     */
    threshold: number | null;
    /**
     * 
     */
    rule_result: ShadowInsuranceRuleResultRuleResultEnum;
    /**
     * 
     */
    evidence: string;
    /**
     * 
     */
    model_name: string | null;
    /**
     * 
     */
    payer_id: string | null;
    /**
     * 
     */
    insurance_type: string;
    /**
     * 
     */
    eligibility_check_id: string | null;
}


/**
 * @export
 */
export const ShadowInsuranceRuleResultRuleTypeEnum = {
    MedicareActiveCoverage: 'medicare_active_coverage',
    MedicareNoMaOrMsp: 'medicare_no_ma_or_msp',
    MedicareSnfDaysRemaining: 'medicare_snf_days_remaining',
    MedicareNoRecentSnfStay: 'medicare_no_recent_snf_stay',
    MedicareQualifyingStay: 'medicare_qualifying_stay',
    MedicareSnfAdmissionWindow: 'medicare_snf_admission_window',
    ManagedMedicareInNetwork: 'managed_medicare_in_network',
    ManagedMedicareActiveCoverage: 'managed_medicare_active_coverage',
    ManagedMedicareSnfCoverage: 'managed_medicare_snf_coverage',
    ManagedMedicareCoverageRunway: 'managed_medicare_coverage_runway',
} as const;
export type ShadowInsuranceRuleResultRuleTypeEnum = typeof ShadowInsuranceRuleResultRuleTypeEnum[keyof typeof ShadowInsuranceRuleResultRuleTypeEnum];

/**
 * @export
 */
export const ShadowInsuranceRuleResultQualifierEnum = {
    DealBreaker: 'Deal Breaker',
    Warning: 'Warning',
} as const;
export type ShadowInsuranceRuleResultQualifierEnum = typeof ShadowInsuranceRuleResultQualifierEnum[keyof typeof ShadowInsuranceRuleResultQualifierEnum];

/**
 * @export
 */
export const ShadowInsuranceRuleResultRuleResultEnum = {
    Pass: 'Pass',
    Fail: 'Fail',
    Unknown: 'Unknown',
} as const;
export type ShadowInsuranceRuleResultRuleResultEnum = typeof ShadowInsuranceRuleResultRuleResultEnum[keyof typeof ShadowInsuranceRuleResultRuleResultEnum];


/**
 * Check if a given object implements the ShadowInsuranceRuleResult interface.
 */
export function instanceOfShadowInsuranceRuleResult(value: object): value is ShadowInsuranceRuleResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('rule_id' in value) || value['rule_id'] === undefined) return false;
    if (!('rule_type' in value) || value['rule_type'] === undefined) return false;
    if (!('rule_title' in value) || value['rule_title'] === undefined) return false;
    if (!('qualifier' in value) || value['qualifier'] === undefined) return false;
    if (!('threshold' in value) || value['threshold'] === undefined) return false;
    if (!('rule_result' in value) || value['rule_result'] === undefined) return false;
    if (!('evidence' in value) || value['evidence'] === undefined) return false;
    if (!('model_name' in value) || value['model_name'] === undefined) return false;
    if (!('payer_id' in value) || value['payer_id'] === undefined) return false;
    if (!('insurance_type' in value) || value['insurance_type'] === undefined) return false;
    if (!('eligibility_check_id' in value) || value['eligibility_check_id'] === undefined) return false;
    return true;
}

export function ShadowInsuranceRuleResultFromJSON(json: any): ShadowInsuranceRuleResult {
    return ShadowInsuranceRuleResultFromJSONTyped(json, false);
}

export function ShadowInsuranceRuleResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowInsuranceRuleResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'rule_id': json['rule_id'],
        'rule_type': json['rule_type'],
        'rule_title': json['rule_title'],
        'qualifier': json['qualifier'],
        'threshold': json['threshold'],
        'rule_result': json['rule_result'],
        'evidence': json['evidence'],
        'model_name': json['model_name'],
        'payer_id': json['payer_id'],
        'insurance_type': json['insurance_type'],
        'eligibility_check_id': json['eligibility_check_id'],
    };
}

export function ShadowInsuranceRuleResultToJSON(json: any): ShadowInsuranceRuleResult {
    return ShadowInsuranceRuleResultToJSONTyped(json, false);
}

export function ShadowInsuranceRuleResultToJSONTyped(value?: ShadowInsuranceRuleResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'rule_id': value['rule_id'],
        'rule_type': value['rule_type'],
        'rule_title': value['rule_title'],
        'qualifier': value['qualifier'],
        'threshold': value['threshold'],
        'rule_result': value['rule_result'],
        'evidence': value['evidence'],
        'model_name': value['model_name'],
        'payer_id': value['payer_id'],
        'insurance_type': value['insurance_type'],
        'eligibility_check_id': value['eligibility_check_id'],
    };
}

